<template>
<!--    <div class="mainFooter">Hyperledger Explorer Client Version: 1.1.8 Fabric Compatibility: v2.3v1.4</div>-->
</template>

<script>
    export default {
    }
</script>

<style scoped lang="scss">
.mainFooter{
    background-color: #e8e8e8;
    height: 20px;
    width: 100%;
    text-align: center;
    /*position: fixed;*/
    /*bottom: 0;*/
    /*z-index: 1;*/
}
</style>